module.exports = __webpack_public_path__ + "static/media/GA.23068526.png";